/**
 * The beats of the celebration.
 *
 * A glow rises off the bottom edge, a confetti volley fires off its crest, and
 * the two fade out together. Shared because the moment is meant to read the
 * same wherever it plays, and until now it was kept that way by a comment —
 * native's `motion.ts` said it was "paced to match web's `Celebration.tsx`",
 * where web held the numbers inline. Two copies kept in step by a note drift
 * the first time one of them is tuned.
 *
 * The glow's beats are both platforms'. The volley's are web's: native draws
 * its own particles and spaces its bursts to suit them, from `motion.ts`.
 */

/** When the glow starts dissolving, which is just after the volley's crest. */
export const CELEBRATION_FADE_START_MS = 300;

/** How long that dissolve takes. Paced so the glow and the confetti end together. */
export const CELEBRATION_FADE_MS = 3200;

/** The whole moment, after which nothing of it is on screen. */
export const CELEBRATION_DURATION_MS = CELEBRATION_FADE_START_MS + CELEBRATION_FADE_MS;

/**
 * When the volley fires: as the glow's rise lands, so it comes off the crest
 * rather than out of a flat band.
 */
export const CELEBRATION_BURST_AT_MS = 150;

/**
 * How far apart the three bursts are spaced, in ms.
 *
 * Small on purpose. They read as one volley of fireworks rather than three
 * events, and the order is reshuffled every play so it is never the same stamp
 * twice.
 */
export const CELEBRATION_BURST_STAGGER_MS = 10;

/** Where across the bottom edge the three bursts originate, as a fraction of width. */
export const CELEBRATION_BURST_ORIGINS = [0.2, 0.5, 0.8] as const;
